module.exports = __webpack_public_path__ + "img/search.dccc703f.svg";